import api from './api';

export interface Source {
  id: number;
  slug: string;
  title: string;
  authors: string | null;
  publicationInfo: string | null;
  url: string;
  createdAt: string;
  updatedAt: string;
}

export interface SourceInput {
  slug?: string;
  title: string;
  authors?: string | null;
  publicationInfo?: string | null;
  url: string;
}

export interface SourceListParams {
  page?: number;
  limit?: number;
  search?: string;
}

export const pmSourcesService = {
  getSources: async (params: SourceListParams = {}) => {
    const res = await api.get('/pm/sources', { params });
    return res.data.data as { data: Source[]; meta: { total: number; page: number; limit: number } };
  },

  createSource: async (input: SourceInput) => {
    const res = await api.post('/pm/sources', input);
    return res.data.data as Source;
  },

  updateSource: async (id: number, input: Partial<SourceInput>) => {
    const res = await api.patch(`/pm/sources/${id}`, input);
    return res.data.data as Source;
  },

  deleteSource: async (id: number) => {
    await api.delete(`/pm/sources/${id}`);
  },
};
